import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/teams/teams.component';
@Component({
	selector: 'app-add-team-dialog',
	templateUrl: './add-team-dialog.component.html',
	styleUrls: ['./add-team-dialog.component.scss'],
	standalone: false,  // NOSONAR
})
export class AddTeamDialogComponent implements OnInit {
	selectedValue;
	selectedOption: number = 0;
	fileUploaded: File;
	storeData: any;
	worksheet: any;
	data: any;
	action;
	local_data;
	initial_data;
	pageName;
	error;
	enableError: boolean = false;
	constructor(public dialogRef: MatDialogRef<AddTeamDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {
		console.info("data store", dataStore);
		this.pageName = dataStore.page;
	}
	ngOnInit(): void { // NOSONAR
		//  do something 
	}
	public onChange(event): void {  // event will give you full breif of action
		this.selectedValue = event.target.value;
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	close(): void {
		this.dialogRef.close();
	}
	public saveClick() {
		if (this.local_data == '' || this.local_data == null || this.local_data == undefined || this.local_data.trim().length == 0) {  // NOSONAR
			this.error = "error";
			this.enableError = true;
		}
		else {
			this.dialogRef.close({ data: this.local_data });
		}
	}
}